import { render, staticRenderFns } from "./popver.vue?vue&type=template&id=a4721e36&scoped=true"
import script from "./popver.vue?vue&type=script&lang=js"
export * from "./popver.vue?vue&type=script&lang=js"
import style0 from "./popver.vue?vue&type=style&index=0&id=a4721e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4721e36",
  null
  
)

export default component.exports